import { useRef } from 'react';

import { useModal } from 'mui-modal-provider';

import { Cluster } from '@cast/types';

import { ResumeClusterDialog } from './ResumeClusterDialog';

import { ShowModalOutput } from '@cast/design-system';

export const useResumeClusterDialog = () => {
  const { showModal } = useModal();
  const modalInstance = useRef<ShowModalOutput>(undefined);

  const openResumeClusterDialog = (cluster: Cluster) => {
    modalInstance.current = showModal(ResumeClusterDialog, {
      onClose: () => modalInstance.current?.destroy(),
      cluster,
    });
  };

  return {
    openResumeClusterDialog,
  };
};
